import { Component } from '@angular/core';

@Component({
  selector: 'app-purchase-portal',
  templateUrl: './purchase-portal.component.html',
  styleUrls: ['./purchase-portal.component.css']
})
export class PurchasePortalComponent {

}
